import request from '@/utils/request'

export function listCouponPropertyUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponProperty.listCouponPropertyUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to load coupon list'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
